import React from 'react';

import SectionMessage from '@atlaskit/section-message';
import { useSession } from 'src/services/session';

const EditV3RuleModal = ({ ruleId }) => {
  const { accountDomain } = useSession();
  return (
    <div style={{ padding: 50 }}>
      <SectionMessage title="Editing V3 rule is not supported">
        <br/>
        Please visit PagerDuty Jira Server extension page to edit this rule.
        <br/>
        Click <a href={`https://${accountDomain}.pagerduty.com/extensions`} target="_blank" rel="noopener noreferrer">here</a> to open PagerDuty extensions
      </SectionMessage>
    </div>
  );
};

export default EditV3RuleModal;
